import { inject, Injectable } from '@angular/core';
import { HashMap, TranslateParams, Translation, TranslocoEvents, TranslocoService } from '@jsverse/transloco';
import { Language, LANGUAGE_LOCAL_STORAGE_KEY } from '@lib/i18n/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private readonly translocoService = inject(TranslocoService);

  changeLanguage(langCode: Language): void {
    this.translocoService.setActiveLang(langCode);
    localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, langCode);
  }

  load(language: Language): Observable<Translation> {
    return this.translocoService.load(language);
  }

  translate(key: TranslateParams, params?: HashMap, lang?: string): string {
    return this.translocoService.translate(key, params, lang);
  }

  getActiveLang(): Language {
    return this.translocoService.getActiveLang() as Language;
  }

  onLangChange(): Observable<TranslocoEvents> {
    return this.translocoService.events$;
  }
}
